import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row mr-3 v-theme--light" }
const _hoisted_2 = {
  key: 0,
  class: "row mr-3 v-theme--light ml-4 no-padding"
}
const _hoisted_3 = { class: "row align-items-center no-padding" }
const _hoisted_4 = { class: "col-12 col-lg" }
const _hoisted_5 = { class: "form-label" }
const _hoisted_6 = { class: "col-12 col-lg text-right" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "col-12 col-lg" }
const _hoisted_9 = { class: "pre-alert-speed" }
const _hoisted_10 = { class: "row align-items-center no-padding" }
const _hoisted_11 = { class: "col-12 col-lg text-right" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "col-12 col-lg" }
const _hoisted_14 = { class: "pre-alert-speed" }
const _hoisted_15 = { class: "row align-items-center no-padding" }
const _hoisted_16 = { class: "col-12 col-lg" }
const _hoisted_17 = { class: "form-label" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "row align-items-center no-padding" }
const _hoisted_20 = { class: "col-12 col-lg" }
const _hoisted_21 = { class: "form-label" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = {
  key: 0,
  class: "row align-items-center no-padding"
}
const _hoisted_24 = { class: "col" }
const _hoisted_25 = { class: "form-label" }
const _hoisted_26 = { class: "col" }

import SettingFormInput from "@/components/VehicleFormParts/SettingFormInput.vue";
import Toggle from "@/components/VehicleFormParts/SettingFormToggle.vue";
import {computed, reactive, ref, toRefs, watch} from 'vue'
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'SpeedAlertSubPreSetting',
  props: {
  modelValue: { type: Object, default: () => ({}) },
  selectDefault: Boolean,
  errors: { type: Object, default: () => ({}) },
  formInputs: {},
  operationOfficeId: null,
  deviceId: null,
  isInstallationOffice: {
    type: Boolean,
    default: false
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props
const isSpeedLimitPreAlert = ref('OFF');
const setPreDelayTime = ref<number>('0');
const isAlertPreTiming = ref('0');
const setSpeedLimitPreInterval = ref<string>('15');
const selectItemSpeedLimitInterval = reactive([
  { title: i18n.global.t('pages.vehicles.form.iniFileSetting.speedAlert.continuous'), value: '0' },
  { title: i18n.global.t('pages.vehicles.form.iniFileSetting.speedAlert.fifteenSeconds'), value: '15' },
  { title: i18n.global.t('pages.vehicles.form.iniFileSetting.speedAlert.thirtySeconds'), value: '30' },
  { title: i18n.global.t('pages.vehicles.form.iniFileSetting.speedAlert.fortyFiveSeconds'), value: '45' },
  { title: i18n.global.t('pages.vehicles.form.iniFileSetting.speedAlert.sixtySeconds'), value: '60' },
]);
const selectItemSpeedLimitTiming = reactive([
  { title: i18n.global.t('pages.vehicles.form.iniFileSetting.speedAlert.onlyExcess'), value: '0' },
  { title: i18n.global.t('pages.vehicles.form.iniFileSetting.speedAlert.continuation'), value: '1' },
]);
const readonlyInputs = ref<any[]>([]);
const { formInputs } = toRefs(props);
const errorKeyPrefix = ref('initial_params.speed_alert');

const form = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const formFieldOptions = computed(() => {
  const parentKey = 'speed_alert';

  return {
    isSpeedLimitPreAlert: getShowAndRequiredAndErrors(parentKey, ['speed_limit_high_pre_on', 'speed_limit_normal_pre_on']),
    isAlertPreTiming: getShowAndRequiredAndErrors(parentKey, ['speed_limit_high_pre_timing', 'speed_limit_normal_pre_timing']),
    speedLimitHighPreThreshold: getShowAndRequiredAndErrors(parentKey, ['speed_limit_high_pre_threshold']),
    speedLimitNormalPreThreshold: getShowAndRequiredAndErrors(parentKey, ['speed_limit_normal_pre_threshold']),
    setPreDelayTime: getShowAndRequiredAndErrors(parentKey, ['speed_limit_high_pre_delay', 'speed_limit_normal_pre_delay']),
  };
});

const isToggleDisabled = computed((): boolean => {
  return (
      (props.selectDefault && readonlyInputs.value.includes('speed_limit_normal_pre_on')
          && readonlyInputs.value.includes('speed_limit_high_pre_on'))
      || form.value.speed_limit_high_on === 'OFF'
      || form.value.speed_limit_normal_on === 'OFF'
  );
});

const emit = __emit;

const autoCompleteToggles = () => {
  isSpeedLimitPreAlert.value = form.value.speed_limit_high_pre_on == 'ON' && form.value.speed_limit_normal_pre_on == 'ON' ? 'ON' : 'OFF';
  if (form.value.speed_limit_high_on == 'OFF' || form.value.speed_limit_normal_on == 'OFF') {
    isSpeedLimitPreAlert.value = 'OFF'
  }
  isAlertPreTiming.value = form.value.speed_limit_high_pre_timing == '1' && form.value.speed_limit_normal_pre_timing == '1' ? '1' : '0';
};

const autoCompleteDelays = () => {
  if (form.value.speed_limit_normal_pre_delay && form.value.speed_limit_high_pre_delay) {
    setPreDelayTime.value = form.value.speed_limit_normal_pre_delay;
  }
};

const autoCompleteSelects = () => {
  if (form.value.speed_limit_normal_pre_interval && form.value.speed_limit_high_pre_interval) {
    setSpeedLimitPreInterval.value = form.value.speed_limit_normal_pre_interval;
  }
};

const getShowAndRequiredAndErrors = (parentKey: string, formKeys: string[]) => {
  if (!props.formInputs?.form[parentKey]) {
    return {
      isShow: false,
      isRequired: false,
      errors: null
    };
  }

  const keys = Object.keys(props.formInputs.form[parentKey]);

  const result = formKeys.map(formKey => {
    return {
      isShow: keys.includes(formKey),
      isRequired: !!props.formInputs.form[parentKey][formKey]?.required,
      errors: props.errors[`${errorKeyPrefix.value}.${formKey}`]
    };
  });

  return {
    isShow: result.every(item => item.isShow),
    isRequired: result.every(item => item.isRequired),
    errors: result.map(item => item.errors).filter(error => error)
  };
};

watch(
    () => form.value.speed_limit_high,
    (newValue: number) => {
      if (newValue < form.value.speed_limit_high_pre_threshold) {
        form.value.speed_limit_high_pre_threshold = newValue < 5 ? 0 : 5; //init
      }
    }
);

watch(
    () => form.value.speed_limit_normal,
    (newValue: number) => {
      if (newValue < form.value.speed_limit_normal_pre_threshold) {
        form.value.speed_limit_normal_pre_threshold = newValue < 5 ? 0 : 5; //init
      }
    }
);

watch(
    () => form.value.speed_limit_high_on,
    (newValue: number) => {
      if (newValue == 'OFF') {
        isSpeedLimitPreAlert.value = 'OFF';
      }
    }
)

watch(() => isSpeedLimitPreAlert.value, (value) => {
  form.value.speed_limit_high_pre_on = value;
  form.value.speed_limit_normal_pre_on = value;
});

watch(() => setPreDelayTime.value, (value) => {
  form.value.speed_limit_high_pre_delay = value;
  form.value.speed_limit_normal_pre_delay = value;
});

watch(() => isAlertPreTiming.value, (value) => {
  form.value.speed_limit_high_pre_timing = value;
  form.value.speed_limit_normal_pre_timing = value;
});

watch(() => setSpeedLimitPreInterval.value, (value) => {
  form.value.speed_limit_high_pre_interval = value;
  form.value.speed_limit_normal_pre_interval = value;
});

watch(() => props.formInputs, () => {
  if (!props.formInputs?.form?.speed_alert) {
    return;
  }
  const key = Object.keys(props.formInputs.default_params)[0];
  readonlyInputs.value = Object.keys(props.formInputs.default_params[key]?.parameters?.speed_alert ?? []);
});

watch(() => props.modelValue, () => {
  if (props.modelValue) {
    autoCompleteToggles();
    autoCompleteDelays();
    autoCompleteSelects();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Toggle, {
      label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.speedLimitPreAlert'),
      modelValue: isSpeedLimitPreAlert.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isSpeedLimitPreAlert).value = $event)),
      formInputs: _unref(formInputs),
      isShow: formFieldOptions.value.isSpeedLimitPreAlert.isShow,
      isRequired: formFieldOptions.value.isSpeedLimitPreAlert.isRequired,
      disabled: isToggleDisabled.value || __props.isInstallationOffice,
      errors: formFieldOptions.value.isSpeedLimitPreAlert.errors
    }, null, 8, ["label", "modelValue", "formInputs", "isShow", "isRequired", "disabled", "errors"]),
    (isSpeedLimitPreAlert.value === 'ON')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.PreAlertSpeedSettings')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(_unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.expresswaySpeed', { speedLimit: form.value.speed_limit_high })), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(SettingFormInput, {
                label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.expresswayKph'),
                modelValue: form.value.speed_limit_high_pre_threshold,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.speed_limit_high_pre_threshold) = $event)),
                isShow: formFieldOptions.value.speedLimitHighPreThreshold.isShow,
                isRequired: formFieldOptions.value.speedLimitHighPreThreshold.isRequired,
                type: "number",
                max: form.value.speed_limit_high,
                colClassNumber: 0,
                formInputs: _unref(formInputs),
                readonly: (__props.selectDefault && readonlyInputs.value.includes('speed_limit_high_pre_threshold')) || __props.isInstallationOffice,
                errors: formFieldOptions.value.speedLimitHighPreThreshold.errors
              }, null, 8, ["label", "modelValue", "isShow", "isRequired", "max", "formInputs", "readonly", "errors"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_i18n_t, { keypath: "pages.vehicles.form.iniFileSetting.speedAlert.preAlertInKph" }, {
                speed: _withCtx(() => [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(form.value.speed_limit_high - form.value.speed_limit_high_pre_threshold), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col" }, [
              _createElementVNode("label", { class: "form-label" })
            ], -1)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", null, _toDisplayString(_unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.generalRoadSpeed', { speedLimit: form.value.speed_limit_normal })), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(SettingFormInput, {
                label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.generalRoadKph'),
                modelValue: form.value.speed_limit_normal_pre_threshold,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.speed_limit_normal_pre_threshold) = $event)),
                isShow: formFieldOptions.value.speedLimitNormalPreThreshold.isShow,
                isRequired: formFieldOptions.value.speedLimitNormalPreThreshold.isRequired,
                type: "number",
                max: form.value.speed_limit_normal,
                colClassNumber: 0,
                formInputs: _unref(formInputs),
                readonly: (__props.selectDefault && readonlyInputs.value.includes('speed_limit_normal_pre_threshold')) || __props.isInstallationOffice,
                errors: formFieldOptions.value.speedLimitNormalPreThreshold.errors
              }, null, 8, ["label", "modelValue", "isShow", "isRequired", "max", "formInputs", "readonly", "errors"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_i18n_t, { keypath: "pages.vehicles.form.iniFileSetting.speedAlert.preAlertInKph" }, {
                speed: _withCtx(() => [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(form.value.speed_limit_normal - form.value.speed_limit_normal_pre_threshold), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.decisionTime')), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(SettingFormInput, {
                label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.decisionTimeSeconds'),
                modelValue: setPreDelayTime.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((setPreDelayTime).value = $event)),
                isShow: formFieldOptions.value.setPreDelayTime.isShow,
                isRequired: formFieldOptions.value.setPreDelayTime.isRequired,
                type: "number",
                max: 600,
                colClassNumber: 0,
                formInputs: _unref(formInputs),
                readonly: (__props.selectDefault && readonlyInputs.value.includes('speed_limit_normal_pre_delay') && readonlyInputs.value.includes('speed_limit_high_pre_delay')) || __props.isInstallationOffice,
                errors: formFieldOptions.value.setPreDelayTime.errors
              }, null, 8, ["label", "modelValue", "isShow", "isRequired", "formInputs", "readonly", "errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.alertTiming')), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_v_select, {
                "hide-details": "auto",
                class: "small mt-2",
                label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.alertTimingLabel'),
                modelValue: isAlertPreTiming.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isAlertPreTiming).value = $event)),
                items: selectItemSpeedLimitTiming,
                clearable: false,
                disabled: (__props.selectDefault && readonlyInputs.value.includes('speed_limit_high_pre_timing') && readonlyInputs.value.includes('speed_limit_normal_pre_timing')) || __props.isInstallationOffice
              }, null, 8, ["label", "modelValue", "items", "disabled"])
            ])
          ]),
          (isAlertPreTiming.value === '1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.alertInterval')), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_v_select, {
                    "hide-details": "auto",
                    class: "small mt-2",
                    label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.alertInterval'),
                    modelValue: setSpeedLimitPreInterval.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((setSpeedLimitPreInterval).value = $event)),
                    items: selectItemSpeedLimitInterval,
                    clearable: false,
                    disabled: __props.isInstallationOffice
                  }, null, 8, ["label", "modelValue", "items", "disabled"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})